import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { getLang, getLocale, setLang as setGlobalLang, subscribeLang, translate } from "../lib/i18n";

const LanguageContext = createContext({
  lang: getLang(),
  locale: getLocale(),
  setLang: setGlobalLang,
  t: (k, v) => translate(getLang(), k, v),
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getLang());

  useEffect(() => subscribeLang(setLangState), []);

  const setLang = useCallback((l) => setGlobalLang(l), []);
  const t = useCallback((k, v) => translate(lang, k, v), [lang]);
  const value = useMemo(() => ({ lang, locale: getLocale(lang), setLang, t }), [lang, setLang, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
